import {
    ARRIVAL_TYPE,
    DEPARTURE_TYPE,
} from '../../../constants';
import {
    STATION_IS_ACTIVE_DEFAULT,
} from '../constants';
import * as types from '../types';

function setStationActive(state, action) {
    const {
        meta: {
            filterId,
            stationId,
            direction,
        },
        payload: isActive,
    } = action;

    const directionType = direction === ARRIVAL_TYPE
        ? ARRIVAL_TYPE
        : DEPARTURE_TYPE;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            stations: {
                ...state[filterId].stations,
                [directionType]: {
                    ...state[filterId].stations[directionType],
                    [stationId]: isActive,
                },
            },
        },
    };
}

function _setOnlyStationActive(stations, onlyStationId, direction) {
    return Object.entries(stations[direction])
        .reduce((map, [stationId, data]) => ({
            ...map,
            [stationId]: onlyStationId === stationId
                ? STATION_IS_ACTIVE_DEFAULT
                : !STATION_IS_ACTIVE_DEFAULT,
        }), {});
}

function _setArriveStationOnlyActive(stations, onlyStationId, direction) {
    return direction === ARRIVAL_TYPE
        ? _setOnlyStationActive(stations, onlyStationId, ARRIVAL_TYPE)
        : stations[ARRIVAL_TYPE];
}

function _setDepartStationOnlyActive(stations, onlyStationId, direction) {
    return direction === DEPARTURE_TYPE
        ? _setOnlyStationActive(stations, onlyStationId, DEPARTURE_TYPE)
        : stations[DEPARTURE_TYPE];
}

function setStationOnlyActive(state, action) {
    const {
        meta: {
            stationId: onlyStationId,
            filterId,
            direction,
        },
    } = action;

    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            stations: {
                [ARRIVAL_TYPE]: _setArriveStationOnlyActive(
                    state[filterId].stations,
                    onlyStationId,
                    direction,
                ),
                [DEPARTURE_TYPE]: _setDepartStationOnlyActive(
                    state[filterId].stations,
                    onlyStationId,
                    direction,
                ),
            },
        },
    };
}

function _resetStations(stations, direction) {
    return Object.entries(stations[direction]).reduce((map, [stationId, data]) => ({
        ...map,
        [stationId]: STATION_IS_ACTIVE_DEFAULT,
    }), {});
}

function _resetArriveStations(stations, direction) {
    return direction === ARRIVAL_TYPE
        ? _resetStations(stations, ARRIVAL_TYPE)
        : stations[ARRIVAL_TYPE];
}

function _resetDepartStations(stations, direction) {
    return direction === DEPARTURE_TYPE
        ? _resetStations(stations, DEPARTURE_TYPE)
        : stations[DEPARTURE_TYPE];
}

function resetStations(state, action) {
    const {
        meta: {
            filterId,
            direction,
        },
    } = action;
    return {
        ...state,
        [filterId]: {
            ...state[filterId],
            stations: {
                [ARRIVAL_TYPE]: _resetArriveStations(state[filterId].stations, direction),
                [DEPARTURE_TYPE]: _resetDepartStations(state[filterId].stations, direction),
            },
        },
    };
}

export default {
    [types.SET_STATION_ACTIVE]: setStationActive,
    [types.SET_STATION_ONLY_ACTIVE]: setStationOnlyActive,
    [types.RESET_STATIONS]: resetStations,
};
